import { EcommPanelParams } from './hooks/useEcommData';
import { isCHBVariant } from '@/hooks/PDP/usePublicationCatalogRelations';
import useGetEcommPanelContent from './hooks/useGetEcommPanelContent';
import EcommPanelCourseHandbook from './EcommPanelCourseHandbook';
import EcommPanelABTreatise from './EcommPanelABTreatise';
import { AnalyticsContext } from '@/analytics/constants';
import { useEffect } from 'react';
import { ItemListAnalyticsModel } from '@/@types/client-api';

type EcommPanelPublicationProps = {
  params: EcommPanelParams;
  onClose: () => void;
  context?: AnalyticsContext;
  setIsLoading?: (loading?: boolean) => void;
  itemListAnalyticsModel?: ItemListAnalyticsModel;
};

const EcommPanelPublication = ({
  params,
  onClose,
  context,
  setIsLoading,
  itemListAnalyticsModel
}: EcommPanelPublicationProps) => {
  const { content, isLoadingContent, isError } = useGetEcommPanelContent(params?.url);

  useEffect(() => {
    if (isError) throw Error;
  }, [isError]);

  useEffect(() => {
    !!setIsLoading && setIsLoading(!!isLoadingContent);
  }, [isLoadingContent, setIsLoading]);

  if (content && isCHBVariant(content)) {
    return (
      <EcommPanelCourseHandbook
        content={content}
        isLoadingContent={isLoadingContent}
        params={params}
        onClose={onClose}
        context={context}
        itemListAnalyticsModel={itemListAnalyticsModel}
      />
    );
  }

  return (
    <EcommPanelABTreatise
      content={content}
      isLoadingContent={isLoadingContent}
      params={params}
      onClose={onClose}
      context={context}
      itemListAnalyticsModel={itemListAnalyticsModel}
    />
  );
};

export default EcommPanelPublication;
